import { render, staticRenderFns } from "./b2bJobList.vue?vue&type=template&id=5dee5cac"
import script from "./b2bJobList.vue?vue&type=script&lang=js"
export * from "./b2bJobList.vue?vue&type=script&lang=js"
import style0 from "./b2bJobList.vue?vue&type=style&index=0&id=5dee5cac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports